import moment from 'moment';
import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import LangSwitcherSC from './lang-switcher.styled';

// import Select from 'react-select';
import { setLangLocalStorage } from '../../helpers/utils-helpers';
import { actions as appActions } from '../../store/ducks/app';
import { LANG_CS_SLUG, LANG_EN_SLUG, LANG_SK_SLUG, TLangSlug } from '../../types/app';
import TStore from '../../types/store';

import { Select } from '@ui';
import CSFlag from '../../assets/png/Flag-CS@2x.png';
import ENFlag from '../../assets/png/Flag-ENG@2x.png';
import SKFlag from '../../assets/png/Flag-SVK@2x.png';

export const LS_THEME_NON_AUTHORIZED = 'non-authorized';
export const LS_THEME_AUTHORIZED = 'authorized';

export type TLangSwitcherProps = {
  theme: typeof LS_THEME_NON_AUTHORIZED | typeof LS_THEME_AUTHORIZED;
  className?: string;
};

const Item: React.FunctionComponent<{ lang: string; src: string }> = ({ lang, src }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img src={src} height="16px" style={{ marginRight: 8 }} />
      <span>{lang}</span>
    </div>
  );
};

const POSITION_OPS = [
  {
    value: LANG_SK_SLUG,
    label: <Item lang={'SK'} src={SKFlag} />,
  },
  {
    value: LANG_CS_SLUG,
    label: <Item lang={'CZ'} src={CSFlag} />,
  },
  {
    value: LANG_EN_SLUG,
    label: <Item lang={'EN'} src={ENFlag} />,
  },
];

const LangSwitcher: React.FC<TLangSwitcherProps> = (props: TLangSwitcherProps) => {
  const { theme, className } = props;
  const dispatch = useDispatch();
  const currentLang = useSelector((store: TStore) => store.app.currentLang);

  const handleBtnClick = (language: TLangSlug) => {
    dispatch(appActions.setLanguage({ language }));
    setLangLocalStorage(language);
    moment.locale(language);
  };

  const selectValue = React.useMemo(
    () => POSITION_OPS.find((o) => o.value === currentLang) || POSITION_OPS[0],
    [currentLang],
  );

  return (
    <LangSwitcherSC variant={theme} className={className}>
      <Select
        options={POSITION_OPS}
        value={selectValue}
        outlined
        onChange={(value) => {
          if (value) {
            // @ts-ignore
            handleBtnClick(value.value);
          }
        }}
        styles={{
          control: () => ({
            minWidth: theme === 'authorized' ? '100px' : 100,
          }),
        }}
        isClearable={false}
        isSearchable={false}
        menuPlacement="auto"
      />
    </LangSwitcherSC>
  );
};

export default React.memo(LangSwitcher);
